import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useProductCustomerPhotosReviewsMin from 'data-hooks/useProductCustomerPhotosReviews/useProductCustomerPhotosReviewsMin';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import getRoundedRating from 'commons/getRoundedRating';
import PDPNameSectionUI from './PDPNameSectionUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPNameSectionPlaceholder from './PDPNameSectionPlaceholder';
const PDPNameSectionInner = t0 => {
  const $ = _c(26);
  const {
    isEditOrder: t1
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    loading,
    error,
    data
  } = usePDPBasicDetails();
  const {
    loading: customerPhotosReviewsLoading,
    data: customerPhotosReviewsData
  } = useProductCustomerPhotosReviewsMin();
  const {
    data: optionsData
  } = usePDPOptions();
  if (!data && loading || !optionsData) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <PDPNameSectionUI loading={true} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  let t2;
  if ($[1] !== data) {
    t2 = data ?? {};
    $[1] = data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    name: t3,
    meta: t4
  } = t2;
  const name = t3 === undefined ? "" : t3;
  let t5;
  if ($[3] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const {
    reviews
  } = t5;
  let t6;
  if ($[5] !== data?.attributes) {
    t6 = data?.attributes?.filter(_temp)[0]?.value;
    $[5] = data?.attributes;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const subtitle = t6;
  let t7;
  if ($[7] !== customerPhotosReviewsData) {
    t7 = customerPhotosReviewsData || {};
    $[7] = customerPhotosReviewsData;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const {
    customer_photos_min: t8,
    customer_reviews: t9
  } = t7;
  let t10;
  if ($[9] !== t8) {
    t10 = t8 === undefined ? {} : t8;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const {
    totalPhotos
  } = t10;
  let t11;
  if ($[11] !== t9) {
    t11 = t9 === undefined ? {} : t9;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const {
    totalReviews
  } = t11;
  const t12 = reviews?.average_score;
  let t13;
  if ($[13] !== t12) {
    t13 = getRoundedRating(t12);
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  const roundedRating = t13;
  let t14;
  if ($[15] !== name || $[16] !== pdpIsModularBYOProduct) {
    t14 = pdpIsModularBYOProduct ? `Build your own ${name.replace(/ modular$/i, "")}` : name;
    $[15] = name;
    $[16] = pdpIsModularBYOProduct;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const finalName = t14;
  const t15 = !customerPhotosReviewsData && customerPhotosReviewsLoading;
  const t16 = (totalPhotos || 0) + (totalReviews || 0);
  let t17;
  if ($[18] !== finalName || $[19] !== isEditOrder || $[20] !== pdpIsModularBYOProduct || $[21] !== roundedRating || $[22] !== subtitle || $[23] !== t15 || $[24] !== t16) {
    t17 = <PDPNameSectionUI name={finalName} subtitle={subtitle} loading={false} reviewsLoading={t15} rating={roundedRating} isEditOrder={isEditOrder} numberOfReviews={t16} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[18] = finalName;
    $[19] = isEditOrder;
    $[20] = pdpIsModularBYOProduct;
    $[21] = roundedRating;
    $[22] = subtitle;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  return t17;
};
PDPNameSectionInner.propTypes = {
  isEditOrder: PropTypes.bool
};
const PDPNameSection = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPNameSectionPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPNameSectionInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPNameSection;
function _temp(item) {
  return item.code === "product_subtitle";
}